import { account, personalProfessional, review } from '../steps'
import payment from './payment'

export default [account, personalProfessional, payment, review]
